/**
 * Expected template
 * 0	 | COMPANY NAME         | LARSEN & TOUBRO LTD       | case insensitive string
​​ * 1	 | PRIMARY IDENTIFIER   | SYMBOL / SCRIPCODE        | case insensitive string
​​ * 2	 | TRANSACTION TYPE     | BUY / SELL                | case insensitive string
 * 3	 | NO OF SHARES         | 100                       | positive integer
​​ * 4	 | TRANSACTION DATE     | 15-07-1990                | DD-MM-YYYY
 * ​​5	 | SHARE PRICE          | 1350                      | positive float
 * ​​6	 | AMOUNT               | 135000                    | positive float
​​ * 7	 | SECONDARY IDENTIFIER | SYMBOL / SCRIPCODE        | case insensitive string
 */

export const zerodha = {
  parse: (txs) => {
    /**
     * Zerodha template (Old)
     * 0  | SYMBOL          | "TATAMOTORS"
     * 1  | ISIN            | "INE155A01022"
     * ​​2  | TRADE DATE      | "2021-01-14"
     * ​​3  | EXCHANGE        | "BSE"
     * ​​4  | SEGMENT         | "EQ"
     * ​​5  | SERIES          | "A"
     * ​​6  | TRADE TYPE      | "buy"
     * ​​7  | NO OF SHARES    | 10
     * ​​8  | SHARE PRICE     | 244.95
     * ​​9  | TRADE ID        | 9557600
     * ​​10 | ORDER ID        | "1610606491629350046"
     * ​​11 | ORDER EXEC TIME |"2021-01-14T14:10:01"
     */
    /**
     * Zerodha template (New)
     * 0  | SYMBOL          | "TATAMOTORS"
     * 1  | ISIN            | "INE155A01022"
     * ​​2  | TRADE DATE      | "2021-01-14"
     * ​​3  | EXCHANGE        | "BSE"
     * ​​4  | SEGMENT         | "EQ"
     * ​​5  | SERIES          | "A"
     * ​​6  | TRADE TYPE      | "buy"
     * 7  | AUCTION         | "FALSE"
     * ​​8  | NO OF SHARES    | 10
     * ​​9  | SHARE PRICE     | 244.95
     * ​​10 | TRADE ID        | 9557600
     * ​​11 | ORDER ID        | "1610606491629350046"
     * ​​12 | ORDER EXEC TIME |"2021-01-14T14:10:01"
     */
    const skipLines = 2;
    const txsLines = txs.slice(skipLines);
    let skipBy = 0;
    if (txsLines[0].length === 13) {
      //new template
      skipBy = 1;
    }
    const parsedTxs = txsLines.map((t) => {
      if (skipBy) t.splice(7, skipBy);
      return [
        null,
        t[0],
        t[6],
        t[7],
        t[2].split('-').reverse().join('-'),
        t[8],
        null,
        t[1],
        t[9],
        t[10],
      ];
    });
    return parsedTxs;
  },
  offset: 16,
};

export const hdfc = {
  parse: (txs) => {
    /**
     * HDFC template
     * 0  | TRADE DATE    | "3-Mar-21"
     * 1  | TRADE NO.     | "2.02103E+15"
     * 2  | ORDER NO.     | "1.1E+15"
     * 3  | EXCHANGE      | "NSE"
     * 4  | SETT NO.      | "2021043"
     * 5  | SETT TYPE     | "N"
     * 6  | TRADE TIME    | "10:37:01"
     * 7  | ORDER TIME    | "10:37:01"
     * 8  | SCRIP NAME    | "GUJARAT STATE PETRONET LI"
     * 9  | TRADE TYPE    | "B"
     * 10 | NO OF SHARES  | "1"
     * 11 | MARKET PRICE  | "291.95"
     * 12 | MARKET VALUE  | "291.95"
     * 13 | SQUP/DEL      | "D"
     * 14 | BROK AMT      | "1.46"
     * 15 | SERVICE TAX   | "0"
     * 16 | STAMP DUTY    | "0.04"
     * 17 | TXN CHARGE    | "0.01"
     * 18 | SERV TAX TXN  | "0"
     * 19 | STT           | "0.29"
     * 20 | SEBI TAX      | "0"
     * 21 | EDU CESS      | "0"
     * 22 | HIGH EDU CESS | "0.26"
     * 23 | OTHER CHRG    | "0"
     * 24 | NET AMT       | "-294.01"
     * 25 | PRODUCT       | "Cash"
     * 26 | SIP FLAG      | "N"
     * 27 | SIP REF NO    | "0"
     */
    const skipLines = 6;
    const txsLines = txs.slice(skipLines);
    const type_map = {
      B: 'BUY',
      S: 'SELL',
    };

    const parsedTxs = txsLines.map((t) => [
      t[8],
      null,
      type_map[t[9]],
      t[10],
      t[0],
      t[11],
      t[12],
      null,
      t[1],
      t[2],
    ]);
    return parsedTxs;
  },
  offset: 8,
};
